import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import "./header.css";

import { CiSearch } from "react-icons/ci";
import { useNavigate, useLocation } from "react-router-dom";

import Photosicon from "../assets/photos_icon.png";
import { IoMdAddCircle } from "react-icons/io";
import { MdAdd } from "react-icons/md";
import { auto_signInWithaooz_user } from "../firebase";



export default function Home_Header() {
  const LOGO_URL ="/logo/aooz_name.png";

  const navigate = useNavigate();
  const location = useLocation();
  const [service_name, setService_name] = useState("");
  const [userlogin, setUserLogin] = useState(false);
  const [search, setSearch] = useState("");

  /* ===============================
     🔐 LOGIN CHECK   //auto_signInWithaooz_user();
  =============================== */
useEffect(() => {
  const status_user = Cookies.get("status_user");

  if (status_user == null) {
  //  window.location.href = "/account-profile";
  }
}, []);

  useEffect(() => { 
    const sessiontoken = Cookies.get("sessiontoken"); 
    setUserLogin(!!sessiontoken);
  }, []);

  return (
    <header className="header">
      <div className="header_size">
        {/* LEFT */}
        <div className="left_body">
          <div className="logo-div" title="Aooz.in">
            <img
              src={LOGO_URL}
              alt="Aooz"
              className="brand-logo"
              onClick={() => navigate("/")}
            />
            <div className="brand-name">{service_name}</div>
          </div>
        </div>

        {/* CENTER */}
        <div className="menus_body"> </div>

        {/* RIGHT */}
        <div className="right_body">
          <div className="searchdiv m-r" onClick={() => auto_signInWithaooz_user()}>
            <CiSearch className="search_icon" />
          </div>
          <div className="addbtn m-r" onClick={() => navigate("/post-status")}>
            <MdAdd className="search_icon" />
          </div>
          {userlogin ? (
            <div
              className="photo_account-sttings"
              onClick={() => navigate("/account")}
            >
              <img
                src={Cookies.get("photoURL") || Photosicon}
                onError={(e) => (e.currentTarget.src = Photosicon)}
                className="Photos-icon"
                alt="Account"
              />
            </div>
          ) : (
            <div className="account-sttings">
              <div
                className="button-ui  text-h3 p-2 "
                onClick={() => navigate("/login")}
              ><IoMdAddCircle className="icon" />
                Login
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
